import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import translationEN from './locales/en/translation.json';
import translationZH from './locales/zh/translation.json';
import translationFR from './locales/fr/translation.json';
import translationES from './locales/es/translation.json';
import translationDE from './locales/de/translation.json';
import translationJA from './locales/ja/translation.json';

// Import English section translations
import resourcesEN from './locales/en/sections/resources.json';
import commonEN from './locales/en/sections/common.json';
import homeEN from './locales/en/sections/home.json';
import contactEN from './locales/en/sections/contact.json';
import authEN from './locales/en/sections/auth.json';
import faqEN from './locales/en/sections/faq.json';
import legalEN from './locales/en/sections/legal.json';
import blogEN from './locales/en/sections/blog.json';

// Set up resources
const resources = {
  en: {
    translation: {
      ...translationEN,
      ...faqEN,
      ...commonEN,
      ...homeEN,
      ...contactEN,
      ...authEN,
      ...blogEN
    },
    resources: resourcesEN,
    legal: legalEN
  },
  zh: {
    translation: translationZH,
    resources: translationZH.resources || {},
    blog: translationZH.blog || {},
    legal: translationZH.legal || legalEN
  },
  fr: {
    translation: translationFR,
    resources: translationFR.resources || {},
    blog: translationFR.blog || {},
    legal: translationFR.legal || legalEN
  },
  es: {
    translation: translationES,
    resources: translationES.resources || {},
    blog: translationES.blog || {},
    legal: translationES.legal || legalEN
  },
  de: {
    translation: translationDE,
    resources: translationDE.resources || {},
    blog: translationDE.blog || {},
    legal: translationDE.legal || legalEN
  },
  ja: {
    translation: translationJA,
    resources: translationJA.resources || {},
    blog: translationJA.blog || {},
    legal: translationJA.legal || legalEN
  }
};

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
